import React, { useState, useEffect, useRef } from 'react'
import FileDownload from 'js-file-download'
import Layout from '../../components/Layout'
import Header from '../../components/shared/Header';
import ExcelIcon from '../../../assets/icons/ic_excel.svg';
import SendIcon from '../../../assets/icons/ic_send-email.svg';
import Search from '../../components/shared/Search';
import CustomSelect from '../../components/shared/CustomSelect';
import InputDate from '../../components/shared/InputDate';
import ListItems from '../../components/shared/ListItems';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import ItemPickingState from '../../components/shared/ItemPickingState';
import Modal from '../../components/shared/Modal';

import './PickingState.scss';
import pickingStateAPI from '../../api/PickingEstateAPI';
import { useDispatch, useSelector } from 'react-redux'
import { loadingActions, filterActions } from '../../redux/actions';
import journeysAPI from '../../api/journeysAPI';
import moment from 'moment';
import EmailsModal from '../../components/shared/EmailsModal';
import storesAPI from '../../api/storesAPI';
import CustomButton from '../../components/shared/CustomButton';
import RadioOption from '../../components/shared/RadioOption';
import MultiInputDate from '../../components/shared/MultiInputDate';
import CloseIcon from '@material-ui/icons/Close';
import AnotherSessionModal from '../../components/shared/AnotherSessionModal';
import { sessionError } from '../../utils/sessionError';

const PickingEstate = () => {

  const history = useHistory()
  // const [filters, setFilters] = useState({
  //   stores:[],
  //   journeys: [],
  //   purchaseDate: null,
  //   compromiseDate: null,
  // })
  const [journeysOption, setJourneysOption] = useState([
    {
      label: 'Jornadas',
      options: [],
    },
  ])
  const [storesOption, setStoresOption] = useState([
    {
      label: 'Sucursal',
      options: [],
    },
  ])
  const [modalSession, setModalSession] = useState(false)
  const [modalError, setModalError] = useState(false)
  const [modalReportError, setModalReportError] = useState(false)
  const [modalEmails, setModalEmails] = useState(false)
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(4);
  const [total, setTotal] = useState(20);
  const [perPage, setPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch()
  const didMounRef = useRef(false);
  const didMounRef3 = useRef(false);
  const [checkOC, setCheckOC] = useState([]);
  const filters = useSelector(state => state.filterReducer.filtersState)
  // Export constants
  const [exportSection, setExportSection] = useState(false)
  const [typeDate, setTypeDate] = useState(0)
  const [purchaseDate, setPurchaseDate] = useState({
    startDate: null,
    endDate: null
  })
  const [dispatchDate, setDispatchDate] = useState({
    startDate: null,
    endDate: null
  })

  useEffect(() => {
    fetchOCS(currentPage, perPage);
    fetchJourneys();
    fetchStores();
    // CLEAN FILTERS FROM ALL OTHER TABS
    cleanAllOtherFilters();
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (perPage !== '') {
        if (didMounRef.current) { onChangePerPage(perPage); console.log('EJECUTNADO USEEFFECT PERPAGE') }
        else didMounRef.current = true;
        // console.log(numElem);
      }
    }, 500);

    return () => {
      clearTimeout(timeout);  // this guarantees to run right before the next effect
    }
    // eslint-disable-next-line
  }, [perPage]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (didMounRef3.current) { onChangePerPage(perPage); console.log('EJECUTNADO USEEFFECT filters') }
      else didMounRef3.current = true;
      // console.log(numElem);
    }, 800);

    return () => {
      clearTimeout(timeout);  // this guarantees to run right before the next effect
    }
    // eslint-disable-next-line
  }, [filters])

  const cleanAllOtherFilters = () => {
    dispatch(filterActions.cleanHistory());
    dispatch(filterActions.cleanResend());
    dispatch(filterActions.cleanReassign());
  }

  const formatFilters = ({ purchaseDate, compromiseDate, journeys, textSearch, stores }) => {
    const newFilters = {
      purchaseDate: purchaseDate && moment(purchaseDate).format('YYYY-MM-DD'),
      compromiseDate: compromiseDate && moment(compromiseDate).format('YYYY-MM-DD'),
      journeys: Array.isArray(journeys) ? journeys : [journeys],
      stores: Array.isArray(stores) ? stores : [stores],
      textSearch
    }
    return newFilters
  }

  const fetchOCS = async (currentPage, perPage) => {
    try {
      dispatch(loadingActions.setLoading(true))
      const { total, purchaseOrders } = await pickingStateAPI.getOCS(currentPage, perPage, formatFilters({ ...filters }));
      console.log(total, purchaseOrders)
      setRows(formatOCS(purchaseOrders));
      setTotal(total)
      setTotalPages(Math.ceil(parseInt(total) / parseInt(perPage)))
      dispatch(loadingActions.setLoading(false))
    } catch (error) {
      console.error(error.message);
      dispatch(loadingActions.setLoading(false))
      if (sessionError(error)) {
        setModalSession(true)
      } else {
        setModalError(true)
      }
    }
  }

  const fetchJourneys = async () => {
    try {
      const journeys = await journeysAPI.getJourneys();
      console.log(journeys, 'journeys')
      const formatJourneys = journeys.map(j => ({ ...j, value: j.code, label: j.name }))
      setJourneysOption([{
        label: 'Jornadas',
        options: formatJourneys,
      }])
    } catch (e) {
      console.log({ ...e })
      if (sessionError(e)) {
        setModalSession(true)
      } 
    }
  }

  const fetchStores = async () => {
    try {
      const stores = await storesAPI.getStores();
      console.log(stores, 'stores')
      const formatStores = stores.map(s => ({ ...s, value: s.id, label: s.name }))
      setStoresOption([{
        label: 'Sucursal',
        options: formatStores,
      }])
    } catch (e) {
      console.log(e)
      if (sessionError(e)) {
        setModalSession(true)
      } 
    }
  }

  const formatOCS = (OCS) => {
    return OCS.map(oc => ({
      ...oc,
      checked: checkOC.includes(oc.orderNumber),
    }))
  }

  const onChangePage = async (numPage, perPage) => {
    setCurrentPage(numPage);
    fetchOCS(numPage, perPage)
  }

  const onChangePerPage = async (perPage) => {
    if (perPage <= 0) return;
    setCurrentPage(1);
    await fetchOCS(1, perPage)
  }

  const handleClickCheckbox = (row, rowIndex) => {
    const newRows = [...rows];
    newRows[rowIndex] = { ...row, checked: !newRows[rowIndex]['checked'] };
    console.log(newRows);
    setRows(newRows);
    // console.log(newRows.map(nr => nr.lpn['value']));
    const rowsUnChecked = newRows.filter(nr => !nr.checked);
    let newCheckOC = [...checkOC];
    newCheckOC.forEach((ncOC, i) => {
      const rowsUnCheckedFounded = rowsUnChecked.find(ruck => ruck['orderNumber'] === ncOC)
      if (rowsUnCheckedFounded) newCheckOC.splice(i, 1);
    });
    setCheckOC([
      ...newCheckOC,
      ...newRows.filter(n => n.checked && !checkOC.includes(n.orderNumber)).map(nr => nr.orderNumber)
    ]);
  }

  const checkRowsChecked = () => {
    return checkOC.length <= 0 ? true : false;
  }

  const exportData = async (purchaseOrders) => {
    try {
      dispatch(loadingActions.setLoading(true))
      const excel = await pickingStateAPI.exportExcelOC(purchaseOrders);
      const dateObj = new Date()
      const month = ('0' + (dateObj.getMonth() + 1)).slice(-2)
      const date = ('0' + dateObj.getDate()).slice(-2)
      const year = dateObj.getFullYear()
      const fileName = `reporte_estados_${date}${month}${year}.xlsx`
      FileDownload(excel, fileName)
      // console.log(excel)
      dispatch(loadingActions.setLoading(false))
    } catch (error) {
      console.log('error ........>', error)
      dispatch(loadingActions.setLoading(false))
      if (sessionError(error)) {
        setModalSession(true)
      } else {
        setModalReportError(true)

      }
    }
  }

  const sendEmail = async emailsList => {
    try {
      dispatch(loadingActions.setLoading(true))
      console.log(emailsList)
      await pickingStateAPI.sendEmailExcelOC(checkOC, emailsList)
      setModalEmails(false)
      dispatch(loadingActions.setLoading(false))
    } catch (e) {
      console.log(e)
      dispatch(loadingActions.setLoading(false))
      if (sessionError(e)) {
        setModalSession(true)
      } 
    }
  }

  const exportAll = async () => {
    try {
      dispatch(loadingActions.setLoading(true))
      const type = typeDate === 0 ? 'V' : 'D';
      const { startDate, endDate } = typeDate === 0 ? purchaseDate : dispatchDate
      const excel = await pickingStateAPI.exportExcelTotalOC(type, moment(startDate).format('YYYY-MM-DD') , moment(endDate).format('YYYY-MM-DD') );
      const dateObj = new Date()
      const month = ('0' + (dateObj.getMonth() + 1)).slice(-2)
      const date = ('0' + dateObj.getDate()).slice(-2)
      const year = dateObj.getFullYear()
      const fileName = `reporte_estados_total_${date}${month}${year}.xlsx`
      FileDownload(excel, fileName)
      // console.log(excel)
      dispatch(loadingActions.setLoading(false))
    } catch (error) {
      console.log('error ........>', error)
      dispatch(loadingActions.setLoading(false))
      if (sessionError(error)) {
        setModalSession(true)
      } else {
        setModalReportError(true)
      }
    }
  }

  const disableExportBtn = () => {
    if(typeDate === 0 && (purchaseDate.startDate && purchaseDate.endDate)) return false;
    if(typeDate === 1 && (dispatchDate.startDate && dispatchDate.endDate)) return false;
    else return true
  }

  const quitExportSection = () => {
    setExportSection(false);
    setPurchaseDate({ startDate: null, endDate: null});
    setDispatchDate({ startDate: null, endDate: null});
    setTypeDate(0)
  }

  return (
    <Layout>
      <AnotherSessionModal isOpen={modalSession} onClose={() => setModalSession(false)} />
      <Modal
        visible={modalError}
        onClose={() => { }}
        title='No hay conexión'
        titleImage={require('../../../assets/icons/ic_disconnected.svg')}
        color='var(--ripley-salmon)'
        btn1={{
          text: 'Volver',
          type: 'secondary',
          onClick: () => {
            setModalError(false)
          }
        }}
        btn2={{
          text: 'Reintentar',
          type: 'primary',
          onClick: () => {
            setModalError(false)
            fetchOCS(currentPage, perPage)
          }
        }}
      >
        <div className='modal-error'>
          <p>Revisa tu conexión a internet e inténtalo de nuevo</p>
        </div>
      </Modal>
      <Modal
        visible={modalReportError}
        onClose={() => setModalReportError(false)}
        title='No hay conexión'
        titleImage={require('../../../assets/icons/ic_disconnected.svg')}
        color='var(--ripley-salmon)'
        btn1={{
          text: 'Volver',
          type: 'secondary',
          onClick: () => {
            setModalReportError(false)
          }
        }}
        btn2={{
          text: 'Reintentar',
          type: 'primary',
          onClick: () => {
            setModalReportError(false)
            exportData(checkOC)
          }
        }}
      >
        <div className='modal-error'>
          <p>No se pudo descargar el reporte. Revisa tu conexión a internet e inténtalo de nuevo</p>
        </div>
      </Modal>
      <EmailsModal
        title='Reenviar reporte por correo'
        titleImage={require('../../../assets/icons/mail.svg')}
        visible={modalEmails}
        onClose={() => setModalEmails(false)}
        onFinish={emailsList => sendEmail(emailsList)}
      />
      <div className='picking-state-container'>
        <Header
          title='Picking'
          subtitle='Reporte de estados'
          btnTitle1='Exportar selección'
          onClickBtn1={() => exportData(checkOC)}
          disabledBtn1={checkRowsChecked()}
          iconBtn1={ExcelIcon}
          btnTitle2='Enviar selección'
          onClickBtn2={() => setModalEmails(true)}
          disabledBtn2={checkRowsChecked()}
          iconBtn2={SendIcon}
          btnTitle3='Exportar todo'
          onClickBtn3={() => setExportSection(true)}
          disabledBtn3={false}
          iconBtn3={ExcelIcon}
        />
        {
          exportSection
            ? <div className='picking-state-export'>
              <div className='picking-state-export-header'>
                <span>Mostrar reportes según</span>
                <div onClick={quitExportSection}>
                  <CloseIcon style={{ color: '#F15B5B'}} />
                </div>
              </div>
              <div className='picking-state-export-dates'>
                <div className='picking-state-export-dates-purchase'>
                  <RadioOption
                    label='Fecha de venta'
                    isChecked={typeDate === 0}
                    onClick={() => {
                      setTypeDate(0);
                      setDispatchDate({startDate:null,endDate:null});
                    }}
                  />
                  <MultiInputDate
                    value1={purchaseDate.startDate}
                    onChange1={(e) => setPurchaseDate({ ...purchaseDate, startDate: e }) }
                    label1='Fecha Inicio'
                    value2={purchaseDate.endDate}
                    onChange2={(e) => setPurchaseDate({ ...purchaseDate, endDate: e })}
                    label2='Fecha Fin'
                    cleanBoth={() => setPurchaseDate({ startDate: null, endDate: null }) }
                    disabled={typeDate}
                    minDate1={purchaseDate.startDate || undefined}
                    maxDate2={purchaseDate.startDate ? moment(purchaseDate.startDate).add(7, 'days') : null}
                    fullWidth
                  />
                </div>
                <div className='picking-state-export-dates-dispatch'>
                  <RadioOption
                    label='Fecha de despacho'
                    isChecked={typeDate === 1}
                    onClick={() => {
                      setTypeDate(1);
                      setPurchaseDate({startDate:null,endDate:null});
                    }}
                  />
                  <MultiInputDate
                    value1={dispatchDate.startDate}
                    onChange1={(e) => setDispatchDate({ ...dispatchDate, startDate: e }) }
                    label1='Fecha Inicio'
                    value2={dispatchDate.endDate}
                    onChange2={(e) => setDispatchDate({ ...dispatchDate, endDate: e }) }
                    label2='Fecha Fin'
                    cleanBoth={() => setDispatchDate({ startDate: null, endDate: null }) }
                    disabled={!typeDate}
                    minDate1={dispatchDate.startDate || undefined}
                    maxDate2={dispatchDate.startDate ? moment(dispatchDate.startDate).add(7, 'days') : null}
                    fullWidth
                  />
                </div>
              </div>
              <CustomButton
                filled
                margin='2em 0 0'
                size='large'
                onClick={exportAll}
                disabled={disableExportBtn()}
                color='#5E388A'>
                  <span className='btnText'>Exportar Reportes</span>
              </CustomButton>
            </div>
            : <>
              <div className='picking-state-filters'>
                <div className='picking-state-search'>
                  <Search
                    placeholder='Busca por OC o DNI'
                    value={filters.textSearch}
                    onChange={text => dispatch(filterActions.setReportStates({ ...filters, textSearch: text }))}
                  />
                </div>
                <div className='picking-state-select workingday'>
                  <CustomSelect
                    value={filters.journeys}
                    onChange={(e, a) => dispatch(filterActions.setReportStates({ ...filters, journeys: e }))}
                    placeholder='Jornadas'
                    options={journeysOption}
                  />
                </div>
                <div className='picking-state-select buy'>
                  <InputDate
                    value={filters.purchaseDate}
                    handleChange={(e) => dispatch(filterActions.setReportStates({ ...filters, purchaseDate: e }))}
                    label='F. Venta'
                    fullWidth
                  />
                </div>
                <div className='picking-state-select dispatch'>
                  <InputDate
                    value={filters.compromiseDate}
                    handleChange={(e) => dispatch(filterActions.setReportStates({ ...filters, compromiseDate: e }))}
                    label='F. Despacho'
                    fullWidth
                  />
                </div>
                <div className='picking-state-select stores'>
                  <CustomSelect
                    value={filters.stores}
                    onChange={(e) => dispatch(filterActions.setReportStates({ ...filters, stores: e }))}
                    placeholder='Sucursales'
                    options={storesOption}
                    multi
                  />
                </div>
              </div>
              <div className='picking-state-table'>
                <ListItems
                  currentPage={currentPage}
                  total={total}
                  perPage={perPage}
                  changePage={onChangePage}
                  totalPages={totalPages}
                  onChangePerPage={(e) => setPerPage(e.target.value)}
                >
                  {rows.map((r, i) => (
                    <ItemPickingState
                      row={r}
                      showCheckbox={true}
                      orderNumber={r.orderNumber}
                      clientDni={r.clientDni}
                      purchaseDate={r.purchaseDate}
                      compromiseDate={r.compromiseDate}
                      storeName={r.storeName}
                      cudsNumber={r.cudsNumber}
                      checked={r.checked}
                      onClickCheckBox={handleClickCheckbox}
                      rowIndex={i}
                      onClickDetail={() => history.push(`/reporte-estados/${r.orderNumber}?storeId=${r.storeId}`)} />
                  ))}
                </ListItems>
              </div>
            </>
        }
      </div>
    </Layout>
  )
}

export default PickingEstate
